import { string, object } from 'yup';

const schema = object().shape({
  id: string().required('requiredField'),
  amount: string().required('requiredField')
});

export default schema;